import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ title, description, keywords, image, url }) => {
    const siteTitle = title ? `${title} | Getsoko` : 'Getsoko - Restaurant Operations Software';
    const siteDescription = description || 'Empower your restaurant operations with Getsoko.';
    const siteImage = image || 'https://getsoko.app/default-og-image.jpg';
    const canonicalUrl = url || 'https://getsoko.app';
    const keywordsString = Array.isArray(keywords) ? keywords.join(', ') : keywords || 'restaurant pos, operations, software';

    return (
        <Helmet>
            {/* Standard HTML Meta Tags */}
            <title>{siteTitle}</title>
            <meta name="description" content={siteDescription} />
            <meta name="keywords" content={keywordsString} />
            <link rel="canonical" href={canonicalUrl} />

            {/* Open Graph / Facebook / LinkedIn */}
            <meta property="og:type" content="article" />
            <meta property="og:title" content={siteTitle} />
            <meta property="og:description" content={siteDescription} />
            <meta property="og:image" content={siteImage} />
            <meta property="og:url" content={canonicalUrl} />

            {/* Twitter Card */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={siteTitle} />
            <meta name="twitter:description" content={siteDescription} />
            <meta name="twitter:image" content={siteImage} />
        </Helmet>
    );
};

export default SEO;